export default __webpack_public_path__ + "static/media/down-arrow.d4824368.svg";